import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_form = _resolveComponent("el-form")

  return (_openBlock(), _createBlock(_component_el_form, {
    inline: true,
    size: "mini"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        label: "每页",
        style: {"margin-bottom":"0"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: _ctx.record,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.record = $event)),
            style: {"width":"50px"},
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onPaging()))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        style: {"margin-bottom":"0"},
        label: "条记录"
      }),
      _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
        default: _withCtx(() => [
          _createVNode(_component_el_pagination, {
            currentPage: _ctx.currentPage1,
            "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => (_ctx.currentPage1 = $event)),
            "page-size": _ctx.record,
            layout: "total, prev, pager, next, jumper",
            total: _ctx.totalNum,
            onCurrentChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onPaging()))
          }, null, 8, ["currentPage", "page-size", "total"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}